import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import {
  SalesBriefingSection,
  StickyCtaBar,
  BriefingApplicationModal,
  FranchiseInquiryModal,
} from '@marketing/components'
import { useHashScroll } from '@/hooks/useHashScroll'
import { MainHero } from '@/components/home/main/MainHero'
import { PainPointsSection } from '@/components/home/main/PainPointsSection'
import { ProblemCarouselSection } from '@/components/home/main/ProblemCarouselSection'
import { AnimationFeatureSection } from '@/components/home/main/AnimationFeatureSection'
import { SampleVideoSection } from '@/components/home/main/SampleVideoSection'
import { WriteSpeakSection } from '@/components/home/main/WriteSpeakSection'
import { ReviewsSection } from '@/components/home/main/ReviewsSection'
import { getMainContent } from './main.content'
import { useNavigate } from 'react-router-dom'

export default function MainLandingPage() {
  // Rebuild copy on language changes; asset URLs and business values stay unchanged.
  const { t: mt, i18n } = useTranslation('marketing')
  const c = getMainContent(mt)
  const [briefingOpen, setBriefingOpen] = useState(false)
  const [franchiseOpen, setFranchiseOpen] = useState(false)
  const navigate = useNavigate()
  const handleBriefing = () => setBriefingOpen(true)
  const handleInquiry = () => setFranchiseOpen(true)
  const handleFindCenter = () => {
    console.info('find center clicked')
    navigate('/about/lc')
  }

  useHashScroll()

  return (
    <>
      {/* #01 Hero */}
      <MainHero
        titleHighlight={c.hero.titleHighlight}
        title={c.hero.title}
        description={c.hero.description}
        emphasis={c.hero.emphasis}
        ctaLabel={c.hero.ctaLabel}
        onFindCenter={handleFindCenter}
      />

      {/* #02 Pain points */}
      <PainPointsSection
        title={c.painPoints.title}
        titleHighlight={c.painPoints.titleHighlight}
        body={c.painPoints.body}
        emphasis={c.painPoints.emphasis}
      />

      {/* #03 Problem + carousel */}
      <ProblemCarouselSection
        titleHighlight={c.problem.titleHighlight}
        title={c.problem.title}
        body={c.problem.body}
        emphasis={c.problem.emphasis}
        carouselCaption={c.problem.carouselCaption}
        images={c.problem.images}
      />

      {/* #04 Animation feature */}
      <AnimationFeatureSection
        titleHighlight={c.animationFeature.titleHighlight}
        title={c.animationFeature.title}
        body={c.animationFeature.body}
        emphasis={c.animationFeature.emphasis}
        columnItemCount={c.animationFeature.columnItemCount}
      />

      {/* #05 Sample video */}
      <SampleVideoSection
        titleHighlight={c.sampleVideo.titleHighlight}
        title={c.sampleVideo.title}
        note={c.sampleVideo.note}
        posters={c.sampleVideo.posters}
        videos={c.sampleVideo.videos}
      />

      {/* #06 Write & speak */}
      <WriteSpeakSection
        title={c.writeSpeak.title}
        titleHighlight={c.writeSpeak.titleHighlight}
        body={c.writeSpeak.body}
        emphasis={c.writeSpeak.emphasis}
      />

      {/* #07 Reviews */}
      <ReviewsSection
        title={c.reviews.title}
        titleHighlight={c.reviews.titleHighlight}
        ctaLabel={c.reviews.ctaLabel}
        cards={c.reviews.cards}
        onMoreClick={i18n.resolvedLanguage === 'en' ? undefined : () => navigate('/reviews')}
      />

      {/* #08 Sales briefing — shared */}
      <SalesBriefingSection
        onBriefingClick={handleBriefing}
        onInquiryClick={() => navigate('/franchise')}
      />

      <StickyCtaBar
        onBriefingClick={handleBriefing}
        onInquiryClick={handleInquiry}
      />

      <BriefingApplicationModal
        open={briefingOpen}
        onClose={() => setBriefingOpen(false)}
      />
      <FranchiseInquiryModal
        open={franchiseOpen}
        onClose={() => setFranchiseOpen(false)}
      />
    </>
  )
}
